<template>
  <div>
    <el-container>
      <el-header>
        <div>
          <el-form
            :model="loginFrom"
            status-icon
            ref="loginFrom"
            label-width="100px"
            style="height: 100%; width: 300px; margin: auto"
          >
            <el-form-item label="账号" prop="account">
              <el-input v-model="loginFrom.account"></el-input>
            </el-form-item>

            <el-form-item label="密码" prop="passwd">
              <el-input
                type="password"
                v-model="loginFrom.passwd"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="custlogin('loginFrom')"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-header>

      <el-main>
        <div style=" font-size: 20px; ">
          <div>图书出口部订货联系方式：</div>
          <div>邮箱：wtckb@xmwaitu.com；wtckb@163.com</div>
          <div>业务电话：+86-592-5050378、5050376</div>
          <div>5050956、2212133、2212855</div>
        </div>
      </el-main>

      <el-footer>
        <div>2017 厦门外图集团有限公司版权所有丨法律声明及隐私条款</div>
        <div>出版物经营许可证：新出发闽批字第XM4002号</div>
        <!-- <div>闽ICP备05024024号‍-1丨闽公安备案 35020602000373号丨出版物经营许可证：新出发闽批字第XM4002号</div> -->
        <!-- <div>地址：厦门市湖里区悦华路八号外图大厦丨电话：0592-5087235丨邮编：361000</div> -->
        <div>
          <el-link href="https://beian.miit.gov.cn/" target="_blank"
            >闽ICP备05024024号-6</el-link
          >
        </div>
        <div>
          <el-link
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020602002313"
            target="_blank"
            >闽公安备案 35020602002313号</el-link
          >
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import Qs from "qs";
import global from "../global.vue";
import AES from "../AES.js";

export default {
  data() {
    return {
      loginFrom: {
        account: "",
        passwd: "",
      },
    };
  },

  methods: {
    custlogin(formName) {
      /*在这里进行跨域请求,测试成功*/
      //set @data = ' slogincode = "350204197510160011" and spassword = "xibc123" '
      var swheresql =
        "(GY_SupplierNo='" +
        this.loginFrom.account +
        "')and(WebCustPW='" +
        AES.encrypt(this.loginFrom.passwd, global.AEScode) +
        "')and(bIsWebCust='出口客户')";
      console.log(swheresql);

      //var encrypts = AES.encrypt('hello,您好',global.AEScode);
      var encrypts = AES.encrypt(swheresql, global.AEScode);
      var dess = AES.decrypt(encrypts, global.AEScode);
      //var encrypts = AES.encrypt(JSON.stringify('hello,您好'),global.AEScode);
      //var dess = JSON.parse(AES.decrypt(encrypts,global.AEScode));

      let that = this;
      axios({
        headers: {
          "Content-type": "text/xml",
        },
        method: "post",
        url: global.sserverip + "khlogin",
        data: encrypts,
      })
        .then(function (res) {
          let oresult = res.data;
          oresult = AES.decrypt(oresult, global.AEScode);

          if (oresult.substring(0, 1) === "1") {
            //登录成功!
            oresult = oresult.substring(1);

            var obj = JSON.parse(oresult);

            // console.log(obj);
            // console.log(global.dateFormat(obj.douttime, "yyyy-mm-dd"));
            // var myDate = new Date();
            // console.log(obj.douttime-myDate);

            var scustomerid = obj.skeyno;
            scustomerid = AES.encrypt(scustomerid, global.AEScode);
            window.localStorage.setItem("scustomerid", scustomerid);

            var stokenenc = AES.encrypt(obj.stoken, global.AEScode);
            window.localStorage.setItem("stoken", stokenenc);

            // var douttimenenc = AES.encrypt(obj.douttime, global.AEScode);
            // window.localStorage.setItem("douttime", douttimenenc);
            window.localStorage.setItem("douttime", obj.douttime);

            console.log(obj.sloginname);
            var sloginname = AES.encrypt(obj.sloginname, global.AEScode);
            window.localStorage.setItem("sloginname", sloginname);

            var str = window.localStorage.getItem("stoken");
            var stokendec = AES.decrypt(str, global.AEScode);

            that.$router.replace("/qtindex/qthomepage");
          } else {
            console.log(oresult);
            alert(oresult);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
      /*在这里进行跨域请求*/
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style>
.el-container {
  height: 100%;
}
.el-header,
.el-footer {
  background-color: #ffffff;
  color: #333;
  text-align: center;
}
.el-header {
  min-height: 200px;
}
.el-footer {
  height: 120px;
  font-size: small;
}
.el-main {
  color: #333;
  text-align: center;
  height: 100%;
  min-height: 400px;
  font-size: small;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
</style>